var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M18.783 20.87h29.014C46.263 9.094 36.194 0 24 0c-1.792 0-3.537.198-5.217.57v20.3zM12.522 20.87V2.917C5.932 6.514 1.214 13.11.203 20.87h12.319zM12.522 27.13H.203c1.011 7.76 5.729 14.356 12.319 17.952V27.13zM18.783 27.13v20.3c1.68.372 3.425.57 5.217.57 12.194 0 22.263-9.094 23.797-20.87H18.783z", fill: "#D80027" })
  );
});